import { z } from 'zod';
import { Password } from './users.js';
export const Role = z.enum([
    /** TESTING_MODE only: every cer_admin permission plus the Testing portal (docs/testing-mode.md). */
    'test_admin',
    'cer_admin',
    'cer_officer',
    'participant_admin',
    'participant_user',
    'applicant',
]);
export const Workbench = z.enum(['cer', 'participant', 'applicant']);
export const AuthProviderKind = z.enum(['local', 'entra']);
export const LoginRequest = z.object({
    username: z.string().min(1).max(200),
    password: z.string().min(1).max(200),
});
export const UserProfile = z.object({
    id: z.string(),
    username: z.string(),
    displayName: z.string(),
    roles: z.array(Role).min(1),
    /** Present for participant/applicant users; null for CER staff. */
    participantId: z.string().nullable(),
    workbench: Workbench,
});
export const LoginResponse = z.object({
    accessToken: z.string(),
    expiresAt: z.string().datetime(),
    user: UserProfile,
});
/** Tells the SPA how to authenticate before any user is signed in. */
export const AuthConfigResponse = z.discriminatedUnion('provider', [
    /** selfRegistration: SELF_REGISTRATION=true, so the login page offers "Create an account". passwordReset: APP_BASE_URL is set, so it offers "Forgot my password". */
    z.object({ provider: z.literal('local'), selfRegistration: z.boolean(), passwordReset: z.boolean() }),
    z.object({
        provider: z.literal('entra'),
        tenantId: z.string(),
        clientId: z.string(),
        authority: z.string().url(),
        scopes: z.array(z.string()),
    }),
]);
const EmailAddress = z.string().trim().toLowerCase().email().max(254);
/** Self-registration (E3, SELF_REGISTRATION=true). The email address is also the sign-in name. */
export const RegistrationRequest = z.object({ email: EmailAddress, displayName: z.string().trim().min(1).max(200), password: Password }).strict();
export const EmailAddressRequest = z.object({ email: EmailAddress }).strict();
export const VerifyEmailRequest = z.object({ token: z.string().min(20).max(200) }).strict();
export const VerifyEmailResponse = z.object({ verified: z.literal(true) });
/** The same reply whether or not an account exists, so the endpoint doesn't reveal who is registered. */
export const AcceptedResponse = z.object({ message: z.string() });
/** E4: set a new password with the token from a reset email. */
export const PasswordResetRequest = z.object({ token: z.string().min(20).max(200), newPassword: Password }).strict();
//# sourceMappingURL=auth.js.map